import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { FormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatDialogModule } from '@angular/material/dialog'
import { MatDividerModule } from '@angular/material/divider'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatMenuModule } from '@angular/material/menu'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatTableModule } from '@angular/material/table'
import { MatTooltipModule } from '@angular/material/tooltip'
import { PipesModule } from '@mmx/pipes'
import { DirectivesModule } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

import { BreadcrumbModule } from '../breadcrumb'
import { ChargeCardModule } from '../payments/charge-card'
import { TransactionsCardModule } from '../payments/transactions-card'
import { SendContactEditDialogModule } from '../send-contact-edit-dialog'
import { InvoiceComponent } from './invoice.component'
import { InvoiceCardModule } from './invoice-card'
import { InvoiceSubtitleModule } from './invoice-subtitle'

@NgModule({
  imports: [
    BreadcrumbModule,
    ChargeCardModule,
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    InvoiceCardModule,
    InvoiceSubtitleModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatProgressBarModule,
    MatSlideToggleModule,
    MatTableModule,
    MatTooltipModule,
    PipesModule,
    TranslateModule,
    TransactionsCardModule,
    DirectivesModule,
    MatDialogModule,
    SendContactEditDialogModule,
  ],
  declarations: [InvoiceComponent],
  exports: [InvoiceComponent],
})
export class InvoiceModule {}
